import { render, staticRenderFns } from "./TableRoleCreator.vue?vue&type=template&id=1061f7a5&scoped=true"
import script from "./TableRoleCreator.vue?vue&type=script&lang=js"
export * from "./TableRoleCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1061f7a5",
  null
  
)

export default component.exports